(() => {
  const bind = root => {
    if (root.dataset.nmKeyboardMenu) return;
    root.dataset.nmKeyboardMenu = 'ready';
    const items = Array.from(root.querySelectorAll('.header__linklist-item.has-dropdown'));
    const parts = item => {
      const trigger = item.querySelector('.header__linklist-link[aria-controls]');
      return {trigger,panel:trigger && document.getElementById(trigger.getAttribute('aria-controls'))};
    };
    const close = item => {
      const {trigger,panel} = parts(item);
      if (!trigger || !panel) return;
      const changed = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded','false');
      panel.hidden = true;
      if (changed) root.dispatchEvent(new CustomEvent('desktop-nav:dropdown:close',{bubbles:true}));
    };
    const open = item => {
      items.filter(other => other !== item).forEach(close);
      const {trigger,panel} = parts(item);
      if (!trigger || !panel) return;
      const changed = trigger.getAttribute('aria-expanded') !== 'true';
      trigger.setAttribute('aria-expanded','true');
      panel.hidden = false;
      panel.classList.remove('is-closing');
      root.currentMegaMenu = panel.classList.contains('mega-menu') ? panel : null;
      if (changed) root.dispatchEvent(new CustomEvent('desktop-nav:dropdown:open',{bubbles:true}));
    };
    root.openDropdown = open;
    root.closeDropdown = close;
    items.forEach(item => item.addEventListener('mouseleave',event => {
      if (event.relatedTarget && !item.contains(event.relatedTarget) && !item.contains(document.activeElement)) close(item);
    }));
    document.documentElement.addEventListener('mouseleave',() => {
      if (!root.contains(document.activeElement)) items.forEach(close);
    });
    root.addEventListener('focusin',event => {
      const item = event.target.closest('.header__linklist-item.has-dropdown');
      if (item && root.contains(item)) open(item);
      else items.forEach(close);
    });
    root.addEventListener('focusout',event => {
      const item = event.target.closest('.header__linklist-item.has-dropdown');
      if (item && !item.contains(event.relatedTarget)) close(item);
    });
    root.addEventListener('keydown',event => {
      const item = event.target.closest('.header__linklist-item.has-dropdown');
      if (!item) return;
      const {trigger,panel} = parts(item);
      if (!trigger || !panel) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        trigger.focus();
        close(item);
      } else if ((event.key === 'ArrowDown' || event.key === ' ') && event.target === trigger) {
        event.preventDefault();
        open(item);
        if (event.key === 'ArrowDown') panel.querySelector('a[href]')?.focus();
      }
    });
    document.addEventListener('pointerdown',event => {
      if (!root.contains(event.target)) items.forEach(close);
    });
  };
  const start = () => document.querySelectorAll('desktop-navigation.nm-icon-navigation').forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
  document.addEventListener('shopify:section:load',start);
})();
